import TeamSpeak from "@/api/TeamSpeak";
import Vue from "vue";
import localForage from "localforage";

const db = localForage.createInstance({
  driver: localForage.INDEXEDDB,
  name: "files",
  storeName: "groupIcons",
});

const state = {
  // { iconid: Number, base64: String }
  files: [],
  // iconid -> true (aynı icon iki clientta varsa çift indirmesin)
  fetching: {},
};

const mutations = {
  saveIcon(state, { iconid, base64 }) {
    iconid = Number(iconid);
    const i = state.files.findIndex((x) => Number(x.iconid) === iconid);
    if (i >= 0) state.files.splice(i, 1, { iconid, base64 });
    else state.files.push({ iconid, base64 });
  },
  markFetching(state, iconid) {
    Vue.set(state.fetching, Number(iconid), true);
  },
  unmarkFetching(state, iconid) {
    Vue.delete(state.fetching, Number(iconid));
  },
};
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const actions = {
  async initState({ state }) {
    try {
      await db.iterate((value) => {
        const iconid = Number(value.iconid);
        if (!state.files.find((x) => Number(x.iconid) === iconid)) {
          state.files.push(value);
        }
      });
    } catch (err) {
      Vue.prototype.$toast.error(err.message);
    }
  },

  async saveIcon({ commit }, payload) {
    try {
      commit("saveIcon", payload);
      await db.setItem(String(payload.iconid), payload);
    } catch (err) {
      Vue.prototype.$toast.error(err.message);
    }
  },

  async getGroupIcons({ dispatch, state, commit }, iconIdList) {
    await dispatch("initState");

    const ids = (iconIdList || [])
      .map((x) => Number(x))
      .filter((n) => Number.isFinite(n) && n > 0)
      .filter((n) => n >= 1000); // custom icons (built-in için indirme gerekmiyor)

    for (const iconid of ids) {
      try {
        if (state.fetching[iconid]) continue;

        const exists = state.files.find((f) => Number(f.iconid) === iconid && f.base64 && f.base64.length > 50);
        if (exists) continue;

        commit("markFetching", iconid);

        // ✅ AVATAR ile aynı mantık: direkt download
let base64 = null;

for (let attempt = 0; attempt < 3; attempt++) {
  try {
    base64 = await TeamSpeak.downloadFile(`/icon_${iconid}`, 0, "");
    break;
  } catch (e) {
    const msg = String(e && (e.message || e.msg || e));
    if (
      msg.includes("2071") ||
      msg.toLowerCase().includes("file transfer limit")
    ) {
      await sleep(250 + attempt * 400);
      continue;
    }
    throw e;
  }
}

if (!base64) {
  throw new Error("icon download failed after retries");
}

await dispatch("saveIcon", { iconid, base64 });

      } catch (err) {
        // icon yoksa / yetki yoksa vs -> sessiz geçebilirsin, istersen toast da açarız
        console.warn("group icon download failed:", iconid, err && (err.message || err));
} finally {
  await sleep(80);
  commit("unmarkFetching", iconid);
}
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
